module.exports = __webpack_public_path__ + "img/5-4.19520e3d.svg";